import useFetchAndTrace from "../../fetchWithTrace";
import settings from "../../../../constants/settings";
import useSWR from "swr";
import useSWRFetcher from "../fetcher";
import { Table } from "../../../models/data";
import { useCustomAlert } from "../../alerts";

interface PickAndPlaceData {
  top: Table;
  bottom: Table;
}

export function usePickAndPlaceData(boardId: string) {
  const fetcher = useSWRFetcher<PickAndPlaceData>();

  const { data, mutate, isValidating } = useSWR(
    `${settings.api_url}/boards/${boardId}/pick-and-place`,
    fetcher,
    {
      revalidateOnFocus: false,
    },
  );

  return {
    pickAndPlaceData: data,
    refreshPickAndPlaceData: () => void mutate(),
    loading: isValidating,
  };
}

export function useDownloadPickAndPlaceFiles() {
  const fetchAndTrace = useFetchAndTrace();
  const customAlert = useCustomAlert();

  const errorHandler = () => {
    customAlert("Failed to download pick and place");
  };

  return (boardId: string, boardProjectName: string) => {
    const getPickAndPlaceHandler = async (response: Response) => {
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement("a");
        link.download = `${boardProjectName}-${boardId}-pick-and-place.zip`;
        link.href = URL.createObjectURL(blob);
        link.click();
      } else {
        throw Error("Failed to get pick and place");
      }
    };

    void fetchAndTrace(
      `${settings.api_url}/boards/${boardId}/pick-and-place-files`,
      getPickAndPlaceHandler,
      errorHandler,
    );
  };
}
